export default {
  title: "Obiettivi",
  description: "Segui il tuo progresso di pianificazione matrimonio",
  stats: {
    pointsEarned: "Punti guadagnati",
    completed: "Completati",
    events: "Eventi",
    level: "Livello",
    unlimited: "Illimitato",
    limited: "Limitato",
    pro: "Pro",
    essential: "Essential",
    free: "Gratuito"
  },
  categories: {
    all: "Tutti",
    events: "Eventi",
    subscription: "Abbonamento",
    engagement: "Coinvolgimento",
    social: "Social"
  },
  ui: {
    points: "punti",
    completedOn: "Completato il",
    noAchievements: "Nessun obiettivo in questa categoria ancora.",
    loading: "Caricamento...",
    error: "Errore nel caricamento degli obiettivi"
  },
  rarity: {
    common: "Comune",
    rare: "Raro",
    epic: "Epico",
    legendary: "Leggendario"
  },
  achievements: {
    firstGuest: "Primo ospite",
    firstTask: "Primo compito",
    budgetSet: "Budget definito",
    firstVendor: "Primo fornitore",
    planningMaster: "Maestro della pianificazione",
    organized: "Organizzato",
    budgetWise: "Saggio con il budget",
    socialite: "Socievole",
    taskMaster: "Maestro dei compiti",
    timeKeeper: "Custode del tempo"
  },
  titles: {
    "Premier Pas": "Primo Passo",
    "Organisateur Multi-événements": "Organizzatore Multi-eventi",
    "Maître des Célébrations": "Maestro delle Celebrazioni",
    "Légende de l'Organisation": "Leggenda dell'Organizzazione",
    "Cupide du Mariage": "Avido di Matrimoni",
    "Roi de la Fête": "Re della Festa",
    "Maître des Fiançailles": "Maestro dei Fidanzamenti",
    "Spécialiste Baby Shower": "Specialista Baby Shower",
    "Organisateur Spirituel": "Organizzatore Spirituale",
    "Maître de Tous les Arts": "Maestro di Tutte le Arti",
    "Utilisateur Fidèle": "Utente Fedele",
    "Expert Premium": "Esperto Premium",
    "Liberté Illimitée": "Libertà Illimitata",
    "Supporter de Wedora": "Sostenitore di Wedora",
    "Planificateur Assidu": "Pianificatore Assiduo",
    "Accro à l'Organisation": "Dipendente dall'Organizzazione",
    Perfectionniste: "Perfezionista",
    "Ambassadeur Wedora": "Ambasciatore Wedora",
    "Ambassadeur WedBox": "Ambasciatore WedBox",
    Mentor: "Mentore",
    "Organisateur débutant": "Organizzatore Principiante",
    "Organisateur confirmé": "Organizzatore Confermato",
    "Maître organisateur": "Organizzatore Maestro",
    "Premier invité": "Primo Ospite",
    "Mariage intime": "Matrimonio Intimo",
    "Grande célébration": "Grande Celebrazione",
    "Planificateur économe": "Pianificatore Economico",
    "Gestionnaire avisé": "Gestore Saggio",
    "Expert financier": "Esperto Finanziario",
    "Chroniqueur débutant": "Cronista Principiante",
    "Maître du temps": "Maestro del Tempo",
    "Bienvenue !": "Benvenuto!",
    "C'est parti !": "Andiamo!",
    "Supporter de WedBox": "Sostenitore di WedBox"
  },
  descriptions: {
    firstGuest: "Aggiungi il tuo primo ospite alla lista",
    firstTask: "Crea il tuo primo compito",
    budgetSet: "Imposta il tuo budget del matrimonio",
    firstVendor: "Aggiungi il tuo primo fornitore",
    planningMaster: "Completa il 50% dei tuoi compiti",
    organized: "Crea 10 compiti",
    budgetWise: "Rimani entro il 90% del tuo budget",
    socialite: "Aggiungi 50 ospiti",
    taskMaster: "Completa 20 compiti",
    timeKeeper: "Crea la tua timeline",
    "Créez votre premier événement": "Crea il tuo primo evento",
    "Gérez 3 événements différents": "Gestisci 3 eventi diversi",
    "Créez 5 événements différents": "Crea 5 eventi diversi",
    "Gérez 10 événements ou plus": "Gestisci 10 o più eventi",
    "Organisez votre premier mariage": "Organizza il tuo primo matrimonio",
    "Organisez 3 anniversaires": "Organizza 3 compleanni",
    "Organisez una cerimonia di fidanzamento": "Organizza una cerimonia di fidanzamento",
    "Organisez un baby shower": "Organizza un baby shower",
    "Organisez un baptême": "Organizza un battesimo",
    "Organisez au moins un événement de chaque type": "Organizza almeno un evento di ogni tipo",
    "Passez au plan Essential": "Passa al piano Essential",
    "Passez au plan Pro": "Passa al piano Pro",
    "Profitez des événements illimités du plan Pro": "Goditi eventi illimitati con il piano Pro",
    "Restez abonné pendant 3 mois": "Rimani iscritto per 3 mesi",
    "Connectez-vous 7 jours consécutifs": "Accedi per 7 giorni consecutivi",
    "Connectez-vous 30 jours consécutifs": "Accedi per 30 giorni consecutivi",
    "Complétez 100% des tâches d'un événement": "Completa il 100% delle attività di un evento",
    "Partagez votre expérience sur les réseaux sociaux": "Condividi la tua esperienza sui social media",
    "Aidez un autre utilisateur avec vos conseils": "Aiuta un altro utente con i tuoi consigli",
    "Complétez 5 tâches": "Completa 5 compiti",
    "Complétez 15 tâches": "Completa 15 compiti",
    "Complétez 50 tâches": "Completa 50 compiti",
    "Ajoutez votre premier invité": "Aggiungi il tuo primo ospite",
    "Ajoutez 20 invités": "Aggiungi 20 ospiti",
    "Ajoutez 100 invités": "Aggiungi 100 ospiti",
    "Créez votre premier budget": "Crea il tuo primo budget",
    "Aggiungi 5 spese": "Aggiungi 5 spese",
    "Restez dans les limites de votre budget": "Rimani entro i limiti del tuo budget",
    "Ajoutez votre premier événement au planning": "Aggiungi il tuo primo evento al programma",
    "Planifiez tous les événements importants": "Pianifica tutti gli eventi importanti",
    "Créez votre compte Wedora": "Crea il tuo account Wedora",
    "Créez votre compte WedBox": "Crea il tuo account WedBox",
    "Complétez l'onboarding": "Completa l'onboarding",
    "Organisez une cérémonie de fiançailles": "Organizza una cerimonia di fidanzamento",
    "Ajoutez 5 dépenses": "Aggiungi 5 spese"
  },
  locked: "Bloccato",
  unlocked: "Sbloccato",
  progress: "Progresso",
  earned: "Guadagnato",
  rewards: {
    points: "{{points}} punti",
    badge: "Distintivo guadagnato",
    unlock: "Funzione sbloccata"
  },
  earnedPoints: "Punti guadagnati",
  pointsCount: "{{earned}} / {{total}}",
  points: "{{count}} punto",
  points_one: "{{count}} punto",
  points_other: "{{count}} punti",
  completedAt: "Completato il {{date}}",
  continue: "Continua",
  empty: {
    title: "Nessun obiettivo",
    description: "Nessun obiettivo in questa categoria al momento."
  }
};
